/* StudioSoie · scripts communs à toutes les pages (chargé en defer par layout/theme.liquid).
   1. Correctif d'autoplay Swiper (Booster) : arrêt quand l'onglet est masqué, pas d'accélération au retour.
   2. Lien d'évitement : focus réel sur <main>.
   3. Fiche produit : libellé de variante mis en forme ; repli du widget d'avis.
   4. Tiroir panier : message cadeau (note du panier) ; fiche produit : Pack rituel (total et ajout groupé). */
(function () {
  'use strict';

  function patchSwiperAutoplay() {
    document.querySelectorAll('.swiper').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || !sw.params || !sw.params.autoplay || el.__ssAutoplayPatched) { return; }
      el.__ssAutoplayPatched = true;
      try {
        sw.params.autoplay.disableOnInteraction = true;
        sw.params.autoplay.pauseOnMouseEnter = true;
        if (sw.autoplay && typeof sw.autoplay.stop === 'function') { sw.autoplay.stop(); }
        setTimeout(function () { if (sw.params.autoplay.enabled && sw.autoplay && typeof sw.autoplay.start === 'function') { sw.autoplay.start(); } }, 50);
      } catch (e) { /* ignore */ }
    });
  }
  function visibilityHandler() {
    document.querySelectorAll('.swiper').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || !sw.autoplay) { return; }
      try { if (document.hidden) { sw.autoplay.stop(); } else if (sw.params && sw.params.autoplay && sw.params.autoplay.enabled) { sw.autoplay.start(); } } catch (e) {}
    });
  }
  document.addEventListener('visibilitychange', visibilityHandler, { passive: true });
  function armSwiperPatch() {
    if (!document.querySelector('.swiper') && !window.Swiper) { return; }
    setTimeout(patchSwiperAutoplay, 100);
    /* Nouveaux carrousels (quick view, panier, contenu chargé) : observation légère, limitée aux ajouts d'éléments */
    var timer = null;
    new MutationObserver(function (muts) {
      var added = false;
      for (var i = 0; i < muts.length && !added; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { added = true; } }
      if (!added) { return; }
      clearTimeout(timer); timer = setTimeout(patchSwiperAutoplay, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', armSwiperPatch); } else { armSwiperPatch(); }

  /* 3. Fiche produit : libellé de la variante sélectionnée mis en forme (« 40x60cm » → « 40 × 60 cm »), sans toucher aux données */
  /* Marché États-Unis (window.SS_US_UNITS posé par snippets/ss-us-units.liquid) : pouces d'abord, centimètres entre parenthèses */
  function toInch(cm) { var n = Math.round(parseFloat(String(cm).replace(',', '.')) / 2.54 * 10) / 10; return (n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)); }
  function formatOption(v) {
    v = String(v || '').trim();
    if (v.indexOf('″') !== -1) { return v; }
    var m = v.match(/^(\d+)\s*[x×]\s*(\d+)\s*(cm)?$/i);
    if (m) { if (window.SS_US_UNITS) { return toInch(m[1]) + '″ × ' + toInch(m[2]) + '″ (' + m[1] + ' × ' + m[2] + ' cm)'; } return m[1] + ' × ' + m[2] + (m[3] ? ' cm' : ''); }
    m = v.match(/^(\d+(?:[.,]\d+)?)\s*(cm|mm)$/i);
    if (m) { if (window.SS_US_UNITS && m[2].toLowerCase() === 'cm') { return toInch(m[1]) + '″ (' + m[1] + ' cm)'; } return m[1] + ' ' + m[2].toLowerCase(); }
    return v;
  }
  var selNames = document.querySelectorAll('[data-swatch-selected-name]');
  if (selNames.length) {
    var fmtAll = function () { selNames.forEach(function (el) { var t = el.textContent, f = formatOption(t.replace(/^[\s:–-]+/, '')); if (f !== t.replace(/^[\s:–-]+/, '') && el.textContent !== ': ' + f) { el.textContent = ': ' + f; } }); };
    setTimeout(fmtAll, 50);
    var mo = new MutationObserver(function () { setTimeout(fmtAll, 0); });
    selNames.forEach(function (el) { mo.observe(el, { childList: true, subtree: true, characterData: true }); });
  }

  var skip = document.querySelector('.ss-skip');
  if (skip) { skip.addEventListener('click', function () { var m = document.getElementById('MainContent'); if (m) { setTimeout(function () { m.focus(); }, 0); } }); }

  /* Avis clients : texte de repli si le widget Judge.me n'a rien rendu (app absente ou avis web désactivés) */
  var rv = document.querySelector('[data-ss-reviews] .jdgm-review-widget');
  if (rv) {
    var rvEmpty = rv.parentNode.querySelector('.ss-reviews__empty');
    var rvCheck = function (n) { if (rv.children.length || rv.textContent.trim()) { return; } if (n > 0) { setTimeout(function () { rvCheck(n - 1); }, 2000); return; } if (rvEmpty) { rvEmpty.hidden = false; } };
    setTimeout(function () { rvCheck(4); }, 3000);
  }

  /* ---- Argent : mise en forme d'un montant en centimes selon shop.money_format ---- */
  function ssMoney(cents, fmt) {
    fmt = fmt || '{{amount_with_comma_separator}} €';
    var n = Math.max(0, Math.round(cents || 0));
    var euros = Math.floor(n / 100), c = ('0' + (n % 100)).slice(-2);
    var grp = function (num, sep) { return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var out;
    if (/amount_no_decimals_with_comma_separator/.test(fmt)) { out = grp(euros, '.'); }
    else if (/amount_no_decimals_with_space_separator/.test(fmt)) { out = grp(euros, ' '); }
    else if (/amount_with_comma_separator/.test(fmt)) { out = grp(euros, '.') + ',' + c; }
    else if (/amount_with_space_separator/.test(fmt)) { out = grp(euros, ' ') + ',' + c; }
    else if (/amount_with_apostrophe_separator/.test(fmt)) { out = grp(euros, "'") + '.' + c; }
    else if (/amount_no_decimals/.test(fmt)) { out = grp(euros, ','); }
    else { out = grp(euros, ',') + '.' + c; }
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, out).trim(); /* garde l'éventuel <span> du format boutique (convertisseur de devises) */
  }
  window.SS_MONEY = ssMoney; /* partagé avec ss-search.js et ss-builder.js */

  /* ---- Tiroir panier : message cadeau enregistré dans la note du panier (débounce) ---- */
  var noteTimer = null;
  function bindCartNote() { document.querySelectorAll('[data-ss-cart-note]').forEach(bindOneNote); }
  function bindOneNote(ta) {
    if (!ta || ta.__ssBound) { return; }
    ta.__ssBound = true;
    var status = ta.parentNode.querySelector('[data-ss-cart-note-status]');
    var saved = ta.getAttribute('data-saved-label') || document.documentElement.getAttribute('data-ss-note-saved') || '';
    ta.addEventListener('input', function () {
      clearTimeout(noteTimer);
      if (status) { status.textContent = ''; }
      noteTimer = setTimeout(function () {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: ta.value }) })
          .then(function (r) { if (r.ok && status) { status.textContent = saved; } })
          .catch(function () {});
      }, 700);
    });
  }
  bindCartNote();
  document.addEventListener('booster:content:update', function () { setTimeout(bindCartNote, 0); });
  document.addEventListener('booster:cart:update', function () { setTimeout(bindCartNote, 50); });

  /* ---- Fiche produit : Pack rituel (article + compagnons, ajout groupé) ---- */
  var pack = document.querySelector('[data-ss-pack]');
  if (pack) {
    var pform = pack.closest('form');
    var fmt = pack.getAttribute('data-money') || '';
    var mainPrice = parseInt(pack.getAttribute('data-main-price'), 10) || 0;
    var mainPriceEl = pack.querySelector('[data-ss-pack-main-price]');
    var totalEl = pack.querySelector('[data-ss-pack-total]');
    var addBtn = pack.querySelector('[data-ss-pack-add]');
    function mainVariantId() { var i = pform && pform.querySelector('[name="id"]'); return (i && i.value) || pack.getAttribute('data-main-variant'); }
    function mainQty() { var q = pform && pform.querySelector('[name="quantity"]'); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
    function rows() {
      var out = [];
      pack.querySelectorAll('[data-ss-pack-item]').forEach(function (cb) {
        var row = cb.closest('.ss-pack__row'), sel = row && row.querySelector('[data-ss-pack-select]');
        var id = cb.getAttribute('data-variant'), price = parseInt(cb.getAttribute('data-price'), 10) || 0;
        if (sel && sel.selectedIndex >= 0) { var o = sel.options[sel.selectedIndex]; id = o.value; price = parseInt(o.getAttribute('data-price'), 10) || price; }
        out.push({ cb: cb, row: row, id: id, price: price, on: cb.checked });
      });
      return out;
    }
    function refresh() {
      var t = mainPrice * mainQty();
      rows().forEach(function (r) {
        var pe = r.row && r.row.querySelector('[data-ss-pack-item-price]');
        if (pe) { pe.innerHTML = ssMoney(r.price, fmt); }
        if (r.on) { t += r.price; }
      });
      if (totalEl) { totalEl.innerHTML = ssMoney(t, fmt); }
      if (mainPriceEl) { mainPriceEl.innerHTML = ssMoney(mainPrice, fmt); }
      if (addBtn) { addBtn.disabled = !rows().some(function (r) { return r.on; }); }
    }
    pack.addEventListener('change', refresh);
    if (pform) { pform.addEventListener('change', function (e) { if (e.target && (e.target.name === 'quantity' || e.target.name === 'id')) { refresh(); } }); }
    document.addEventListener('booster:variant:select', function (e) {
      var d = e.detail || {};
      if (d.product && String(d.product.id) === pack.getAttribute('data-product-id') && d.selectedVariant && typeof d.selectedVariant.price !== 'undefined') {
        mainPrice = parseInt(d.selectedVariant.price, 10) || mainPrice; refresh();
      }
    });
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        var list = [{ id: parseInt(mainVariantId(), 10), quantity: mainQty() }];
        rows().forEach(function (r) { if (r.on && r.id) { list.push({ id: parseInt(r.id, 10), quantity: 1 }); } });
        /* BoosterTheme est une constante globale (const), pas une propriété de window */
        if (typeof BoosterTheme !== 'undefined' && BoosterTheme.cart && typeof BoosterTheme.cart.addToCartJSON === 'function') {
          BoosterTheme.cart.addToCartJSON(e, { items: list });
          return;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        addBtn.disabled = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function () { window.location.href = root + 'cart'; })
          .catch(function () { addBtn.disabled = false; });
      });
    }
    refresh();
  }

  /* ---- Fiche produit : la photo suit toujours le coloris choisi (run 8).
     Booster cherche une photo rattachée à la combinaison exacte (coloris + taille) ; quand la photo n'est rattachée qu'à une taille,
     rien ne bouge. Repli : on cherche une photo portant la même valeur d'option (le coloris d'abord) et on clique sa vignette. ---- */
  (function () {
    function holderEl() { return document.querySelector('.slider--product-holder[data-bstr-slide-holder]'); }
    function sync(t) {
      var opts = t && t.currentOptions; var h = holderEl();
      if (!opts || !opts.length || !h || opts.some(function (o) { return o === false; })) { return; }
      var exact = '|' + opts.join('#') + '|';
      var slides = Array.prototype.slice.call(h.children);
      if (slides.some(function (s) { return (s.getAttribute('data-variants') || '').indexOf(exact) >= 0; })) { return; }
      var found = -1;
      for (var i = 0; i < opts.length && found < 0; i++) {
        for (var k = 0; k < slides.length && found < 0; k++) {
          var parts = (slides[k].getAttribute('data-variants') || '').split('|');
          for (var j = 0; j < parts.length; j++) { if (parts[j] && parts[j].split('#')[i] === opts[i]) { found = k; break; } }
        }
      }
      if (found < 0) { return; }
      var id = h.getAttribute('data-bstr-slider-id');
      var thumb = document.querySelector('[data-bstr-slider-thumb="' + found + '"]' + (id ? '[data-bstr-slider-for="' + id + '"]' : ''));
      if (thumb) { thumb.click(); }
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      try {
        if (window.BoosterTheme && BoosterTheme.events && typeof BoosterTheme.events.on === 'function') {
          clearInterval(iv);
          BoosterTheme.events.on('booster:swatch:update', function (t) { setTimeout(function () { sync(t); }, 80); });
        }
      } catch (e) {}
      if (tries > 40) { clearInterval(iv); }
    }, 250);
  })();

  /* ---- Devises (16 oct. 2026) : les paliers (livraison offerte, cadeaux) sont réglés en euros, le panier est dans la devise du visiteur.
     ssRate() = taux Shopify de la devise active (1 en euros) ; ssGiftLocalize() reconstruit la barre à paliers dans cette devise. ---- */
  function ssRate() {
    try { var c = window.Shopify && window.Shopify.currency; if (c && c.rate) { var r = parseFloat(c.rate); if (r > 0) { return r; } } } catch (e) {}
    return 1;
  }
  function ssGiftLocalize() {
    document.querySelectorAll('[data-ss-gift]').forEach(function (el) {
      var shopCur = el.getAttribute('data-shop-currency') || '', cartCur = el.getAttribute('data-cart-currency') || '';
      if (!shopCur || !cartCur || shopCur === cartCur || el.__ssLoc) { return; }
      var rate = ssRate(); if (rate === 1) { return; }
      el.__ssLoc = true;
      var fmt = el.getAttribute('data-money') || '', base = parseInt(el.getAttribute('data-base'), 10) || 0;
      var money = function (cents) { return ssMoney(cents, fmt).replace(/([.,])00(?=\D|$)/, ''); };
      var tiers = []; try { tiers = JSON.parse(el.getAttribute('data-tiers') || '[]'); } catch (e) {}
      var fs = Math.round((parseInt(el.getAttribute('data-fs'), 10) || 0) * rate);
      var steps = [];
      if (fs > 0) { steps.push({ kind: 'ship', amount: fs, label: el.getAttribute('data-l-ship') || '' }); }
      tiers.forEach(function (t) { steps.push({ kind: 'gift', amount: Math.round(t.amount * rate), label: el.getAttribute('data-l' + t.tier) || '' }); });
      if (!steps.length) { return; }
      var max = 0; steps.forEach(function (st) { if (st.amount > max) { max = st.amount; } });
      var next = null; for (var i = 0; i < steps.length; i++) { if (base < steps[i].amount) { next = steps[i]; break; } }
      var text = el.querySelector('.ss-gift__text');
      if (text) {
        var icon = next ? (next.kind === 'ship' ? 'uil-truck' : 'uil-gift') : 'uil-check-circle', tpl;
        if (!next) { tpl = el.getAttribute('data-t-all') || ''; }
        else if (next.kind === 'ship') { tpl = (el.getAttribute('data-t-ship') || '').replace('[amount]', money(next.amount - base)); }
        else { tpl = (el.getAttribute('data-t-gift') || '').replace('[amount]', money(next.amount - base)).replace('[gift]', next.label); }
        text.innerHTML = '<i class="uil ' + icon + '" aria-hidden="true"></i> ' + tpl;
      }
      el.classList.toggle('is-complete', !next);
      var fill = el.querySelector('.ss-gift__fill'); if (fill && max > 0) { fill.style.width = Math.min(100, Math.round(base * 100 / max)) + '%'; }
      var dots = el.querySelectorAll('.ss-gift__dot'), legs = el.querySelectorAll('.ss-gift__leg');
      steps.forEach(function (st, i) {
        if (dots[i]) { dots[i].style.left = Math.round(st.amount * 100 / max) + '%'; dots[i].classList.toggle('is-on', base >= st.amount); }
        if (legs[i]) { legs[i].textContent = st.label + ' · ' + money(st.amount); legs[i].classList.toggle('is-on', base >= st.amount); }
      });
    });
  }
  /* Barre « livraison offerte » de l'en-tête (Booster) : même conversion au chargement ; Booster la met ensuite à jour avec la constante convertie */
  function ssFsLocalize() {
    document.querySelectorAll('[data-ss-fsbar]').forEach(function (el) {
      var shopCur = el.getAttribute('data-shop-currency') || '', cartCur = el.getAttribute('data-cart-currency') || '';
      if (!shopCur || !cartCur || shopCur === cartCur || el.__ssLoc) { return; }
      var rate = ssRate(); if (rate === 1) { return; }
      el.__ssLoc = true;
      var goal = Math.round((parseInt(el.getAttribute('data-goal'), 10) || 0) * rate), total = parseInt(el.getAttribute('data-total'), 10) || 0;
      if (goal <= 0) { return; }
      var left = Math.max(0, goal - total), txt = el.querySelector('[data-free-shipping-text]'), bar = el.querySelector('[data-free-shipping-bar]');
      if (txt) { txt.innerHTML = left === 0 ? (txt.getAttribute('data-got-free-shipping') || '') : (txt.getAttribute('data-free-shipping-text') || '').replace('%AMOUNT%', '<span class="jsPrice">' + ssMoney(left, el.getAttribute('data-money') || '') + '</span>'); }
      if (bar) { bar.style.width = Math.min(100, Math.round(total * 100 / goal)) + '%'; }
    });
  }
  ssGiftLocalize(); ssFsLocalize();
  document.addEventListener('ss:cart:rendered', ssGiftLocalize);
  document.addEventListener('booster:content:update', function () { setTimeout(ssGiftLocalize, 0); });

  /* ---- Cadeaux par paliers (snippets/ss-gift-bar.liquid) : ajout / retrait automatique du cadeau selon le sous-total hors cadeaux ---- */
  (function () {
    var busy = false, lastSig = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function tiersOf() { var el = document.querySelector('[data-ss-gift]'); if (!el || el.getAttribute('data-auto') !== '1') { return null; } try { return JSON.parse(el.getAttribute('data-tiers') || '[]'); } catch (e) { return null; } }
    /* 11 oct. 2026 : si Shopify préfère une autre remise au cadeau (ex. « −10 % dès 2 articles » sur un gros panier), le cadeau resterait payant :
       on le retire et on mémorise ce sous-total ; on réessaiera dès que le panier change (avant : désactivation pour toute la session). */
    function refused() { try { return sessionStorage.getItem('ss_gift_refused') || ''; } catch (e) { return ''; } }
    function setRefused(v) { try { if (v === '') { sessionStorage.removeItem('ss_gift_refused'); } else { sessionStorage.setItem('ss_gift_refused', String(v)); } } catch (e) {} }
    function refresh() { try { if (typeof window.SSC_REFETCH === 'function') { window.SSC_REFETCH(); } } catch (e) {} try { if (typeof BoosterTheme !== 'undefined' && BoosterTheme && BoosterTheme.cart && typeof BoosterTheme.cart.dispatchListeners === 'function') { BoosterTheme.cart.dispatchListeners({ change: true }); return; } } catch (e) {} }
    function reconcile(cart) {
      var tiers = tiersOf(); if (!tiers || !tiers.length || busy) { return; }
      var items = cart.items || [], base = 0, gifts = {};
      items.forEach(function (it) { var g = it.properties && it.properties._ss_gift; if (g) { gifts[g] = it; } else if (!(it.properties && it.properties._ss_priority)) { base += it.final_line_price || 0; } });
      var sig = base + '|' + Object.keys(gifts).join(','); if (sig === lastSig) { return; } lastSig = sig;
      if (refused() !== '' && refused() !== String(base)) { setRefused(''); }
      var skipAdd = refused() === String(base);
      var ops = [];
      /* cadeau présent mais facturé (Shopify a retenu une autre remise) : on le retire et on mémorise ce sous-total */
      var rate = ssRate(); tiers = tiers.map(function (t) { return { tier: t.tier, variant: t.variant, amount: Math.round(t.amount * rate) }; }); /* paliers en euros → devise du panier */
      /* 16 oct. 2026 : les cadeaux sont désormais des produits à 0 € (plus de remise automatique « X achetés, Y offert », qui bloquait les codes promo).
         Une ligne cadeau d'un ancien panier (variante payante) ou d'une variante qui n'est plus celle du palier est retirée, puis le bon cadeau est réajouté. */
      Object.keys(gifts).forEach(function (k) {
        var t = null; tiers.forEach(function (x) { if ('tier-' + x.tier === k) { t = x; } });
        if (!t || String(gifts[k].variant_id) !== String(t.variant)) { ops.push({ remove: gifts[k].key }); delete gifts[k]; }
        else if ((gifts[k].quantity || 1) > 1) { ops.push({ qty: gifts[k].key }); }
      });
      var missing = !skipAdd && tiers.some(function (t) { return base >= t.amount && !gifts['tier-' + t.tier]; });
      var paidNow = missing ? [] : Object.keys(gifts).filter(function (k) { return (gifts[k].final_line_price || 0) > 0; });
      if (paidNow.length) { setRefused(base); skipAdd = true; paidNow.forEach(function (k) { ops.push({ remove: gifts[k].key }); delete gifts[k]; }); }
      tiers.forEach(function (t) {
        var key = 'tier-' + t.tier, present = gifts[key], eligible = base >= t.amount;
        if (eligible && !present && !skipAdd) { ops.push({ add: { id: t.variant, quantity: 1, properties: { _ss_gift: key } } }); }
        if (!eligible && present) { ops.push({ remove: present.key }); }
      });
      if (!ops.length) { return; }
      busy = true;
      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () {
          if (op.add) { return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [op.add] }) }); }
          if (op.qty) { return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: op.qty, quantity: 1 }) }); }
          return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: op.remove, quantity: 0 }) });
        }).catch(function () {});
      });
      chain.then(function () {
        /* garde-fou : si la réduction automatique « cadeau » n'est pas active, le cadeau resterait payant → on le retire et on n'insiste pas */
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c2) {
          if (!c2) { return; }
          var paid = (c2.items || []).filter(function (it) { return it.properties && it.properties._ss_gift && it.final_line_price > 0; });
          if (!paid.length) { return; }
          var b2 = 0; (c2.items || []).forEach(function (it) { if (!(it.properties && it.properties._ss_gift)) { b2 += it.final_line_price || 0; } }); setRefused(b2);
          var ch = Promise.resolve();
          paid.forEach(function (it) { ch = ch.then(function () { return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) }); }); });
          return ch;
        });
      }).catch(function () {}).then(function () { busy = false; lastSig = ''; refresh(); });
    }
    function check() {
      if (!tiersOf()) { return; }
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c) { reconcile(c); } }).catch(function () {});
    }
    /* 14 oct. 2026 : Booster déclare « const BoosterTheme » (variable globale, PAS window.BoosterTheme) : l'ancien test window.BoosterTheme
       échouait toujours → le cadeau n'était ajouté qu'au chargement de page suivant, jamais juste après « Ajouter au panier ». */
    function arm() {
      try { if (typeof BoosterTheme !== 'undefined' && BoosterTheme && BoosterTheme.events && typeof BoosterTheme.events.on === 'function' && !arm.done) { arm.done = true; BoosterTheme.events.on('booster:cart:update', function () { setTimeout(check, 150); }); } } catch (e) {}
    }
    document.addEventListener('ssh:cart', function () { setTimeout(check, 150); });
    var tries = 0; var iv = setInterval(function () { arm(); if (arm.done || ++tries > 40) { clearInterval(iv); } }, 250);
    if (document.querySelector('[data-ss-gift]')) { setTimeout(check, 800); }
    window.SSGift = { check: check };
  })();

  /* ---- Préparation prioritaire (snippets/ss-priority-option.liquid, 30 oct. 2026) : case dans le panier → ajout / retrait du produit service ---- */
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var busy = false;
    function refresh() { try { if (typeof window.SSC_REFETCH === 'function') { window.SSC_REFETCH(); } } catch (e) {} try { if (typeof BoosterTheme !== 'undefined' && BoosterTheme && BoosterTheme.cart && typeof BoosterTheme.cart.dispatchListeners === 'function') { BoosterTheme.cart.dispatchListeners({ change: true }); } } catch (e) {} }
    function post(path, body) { return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); }
    function cart() { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }); }
    function lineOf(c) { return (c.items || []).filter(function (it) { return it.properties && it.properties._ss_priority; })[0] || null; }
    function paidLines(c) { return (c.items || []).filter(function (it) { return !(it.properties && (it.properties._ss_gift || it.properties._ss_priority)); }).length; }
    function off() { try { return sessionStorage.getItem('ss_prio_off') === '1'; } catch (e) { return false; } }
    function setOff(v) { try { if (v) { sessionStorage.setItem('ss_prio_off', '1'); } else { sessionStorage.removeItem('ss_prio_off'); } } catch (e) {} }
    function toggle(el, on) {
      if (busy) { return; } busy = true;
      var variant = parseInt(el.getAttribute('data-variant'), 10);
      cart().then(function (c) {
        if (!c) { return; }
        var line = lineOf(c);
        if (on && !line) { setOff(false); return post('cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _ss_priority: '1' } }] }); }
        if (!on && line) { setOff(true); return post('cart/change.js', { id: line.key, quantity: 0 }); }
      }).catch(function () {}).then(function () { busy = false; refresh(); });
    }
    document.addEventListener('change', function (e) {
      var inp = e.target && e.target.closest && e.target.closest('[data-ss-prio-check]'); if (!inp) { return; }
      var el = inp.closest('[data-ss-prio]'); if (!el) { return; }
      el.classList.toggle('is-on', inp.checked);
      toggle(el, inp.checked);
    });
    /* cohérence : option seule dans le panier → retirée ; pré-cochage (réglage) → ajout automatique tant que le client ne l'a pas décochée */
    function check() {
      var el = document.querySelector('[data-ss-prio]');
      cart().then(function (c) {
        if (!c) { return; }
        var line = lineOf(c), paid = paidLines(c);
        if (line && paid === 0) { return post('cart/change.js', { id: line.key, quantity: 0 }).then(function () { refresh(); }); }
        if (el && el.getAttribute('data-prechecked') === '1' && !line && paid > 0 && !off()) {
          var variant = parseInt(el.getAttribute('data-variant'), 10);
          return post('cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _ss_priority: '1' } }] }).then(function () { refresh(); });
        }
      }).catch(function () {});
    }
    document.addEventListener('ssh:cart', function () { setTimeout(check, 400); });
    document.addEventListener('ss:cart:rendered', function () { setTimeout(check, 400); });
    if (document.querySelector('[data-ss-prio]') || document.querySelector('[data-ss-gift]')) { setTimeout(check, 1200); }
    window.SSPriority = { check: check };
  })();

  /* ---- « Récemment consultés » (snippets/ss-recently-viewed.liquid) — run 10 :
     entrées { h: handle, v: variante, c: coloris } (anciennes entrées « handle » acceptées) ; la carte reprend le coloris
     choisi ou survolé en dernier ; × pour retirer une carte ; glisser-déposer pour réordonner (souris) ; cartes centrées. ---- */
  var RV_KEY = 'ss_rv';
  function rvNorm(x) { return typeof x === 'string' ? { h: x } : (x && x.h ? x : null); }
  function rvRead() { try { var a = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); return Array.isArray(a) ? a.map(rvNorm).filter(Boolean) : []; } catch (e) { return []; } }
  function rvWrite(a) { try { localStorage.setItem(RV_KEY, JSON.stringify(a.slice(0, 12))); } catch (e) {} }
  function rvRecord(handle, extra) {
    if (!handle) { return; }
    var a = rvRead(), cur = null;
    a = a.filter(function (x) { if (x.h === handle) { cur = x; return false; } return true; });
    cur = cur || { h: handle };
    if (extra) { if (extra.v) { cur.v = extra.v; } if (extra.c) { cur.c = extra.c; } }
    a.unshift(cur); rvWrite(a);
  }
  function rvRemove(handle) { rvWrite(rvRead().filter(function (x) { return x.h !== handle; })); }
  function rvEsc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rvNormStr(t) { return String(t || '').toLowerCase().replace(/\s+/g, ''); }
  function rvPick(p, entry) {
    var vs = p.variants || [], v = null;
    if (entry.c) {
      var ci = -1; (p.options || []).forEach(function (o, i) { var n = (o && o.name) ? o.name : o; if (ci < 0 && /couleur|coloris|colou?r|farbe|colore|kleur|farve|färg|farge|väri|barva|szín|kolor|χρώμα|culoare|\bcor\b|цвет|колір|צבע|لون/i.test(String(n))) { ci = i; } });
      if (ci >= 0) {
        var same = function (x) { return rvNormStr(x.options[ci]) === rvNormStr(entry.c); };
        if (entry.v) { v = vs.filter(function (x) { return String(x.id) === String(entry.v) && same(x); })[0] || null; }
        v = v || vs.filter(function (x) { return same(x) && x.available; })[0] || vs.filter(same)[0] || null;
      }
    }
    if (!v && entry.v) { v = vs.filter(function (x) { return String(x.id) === String(entry.v); })[0] || null; }
    return v;
  }
  function rvImg(p, v) {
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    if (!src) { return ''; }
    var s = String(src).replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_400x$1$2');
    return '<img src="' + rvEsc(s) + '" alt="" loading="lazy" width="200" height="240" draggable="false">';
  }
  function rvCard(p, entry, fmt, T) {
    var v = rvPick(p, entry);
    var pr = v ? v.price : p.price, cp = v ? v.compare_at_price : p.compare_at_price;
    var price = ssMoney(pr, fmt), cmp = cp && cp > pr ? '<s>' + ssMoney(cp, fmt) + '</s>' : '';
    var url = p.url + (v ? (p.url.indexOf('?') < 0 ? '?' : '&') + 'variant=' + v.id : '');
    var sub = v && entry.c ? '<span class="ss-rv__var">' + rvEsc(entry.c) + '</span>' : '';
    return '<li class="ss-rv__card" data-h="' + rvEsc(p.handle) + '"><a class="ss-rv__link" href="' + rvEsc(url) + '" draggable="false"><span class="ss-rv__img">' + rvImg(p, v) + '</span><span class="ss-rv__name">' + rvEsc(p.title) + '</span>' + sub + '<span class="ss-rv__price">' + cmp + '<span>' + price + '</span></span></a>' +
      '<button type="button" class="ss-rv__rm" data-ss-rv-rm aria-label="' + rvEsc((T.rm || 'Retirer') + ' : ' + p.title) + '"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></li>';
  }
  function rvSaveOrder(ul) {
    var order = Array.prototype.map.call(ul.querySelectorAll('.ss-rv__card'), function (li) { return li.getAttribute('data-h'); });
    var all = rvRead(), byH = {}; all.forEach(function (x) { byH[x.h] = x; });
    var head = all.filter(function (x) { return order.indexOf(x.h) < 0; }).slice(0, 1); /* le produit courant (exclu de l'affichage) reste en tête */
    var mid = order.map(function (h) { return byH[h] || { h: h }; });
    var rest = all.filter(function (x) { return order.indexOf(x.h) < 0 && head.indexOf(x) < 0; });
    rvWrite(head.concat(mid, rest));
  }
  function rvDnD(ul) {
    if (ul.__ssDnd || !window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) { return; }
    ul.__ssDnd = true; var drag = null;
    ul.addEventListener('dragstart', function (e) { drag = e.target.closest('.ss-rv__card'); if (!drag) { return; } drag.classList.add('is-drag'); try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', drag.getAttribute('data-h')); } catch (er) {} });
    ul.addEventListener('dragover', function (e) {
      if (!drag) { return; } e.preventDefault();
      var over = e.target.closest('.ss-rv__card'); if (!over || over === drag) { return; }
      var r = over.getBoundingClientRect(), after = (e.clientX - r.left) > r.width / 2;
      ul.insertBefore(drag, after ? over.nextSibling : over);
    });
    ul.addEventListener('drop', function (e) { if (drag) { e.preventDefault(); } });
    ul.addEventListener('dragend', function () { if (!drag) { return; } drag.classList.remove('is-drag'); drag = null; rvSaveOrder(ul); });
  }
  function rvRender() {
    var boxes = document.querySelectorAll('[data-ss-rv]');
    if (!boxes.length) { return; }
    boxes.forEach(function (box) {
      if (box.__ssRendering) { return; }
      var exclude = box.getAttribute('data-ss-rv-record') || '';
      var root = box.getAttribute('data-root') || '/', fmt = box.getAttribute('data-money') || '', max = parseInt(box.getAttribute('data-max'), 10) || 6;
      var T = { rm: box.getAttribute('data-t-rm') || '' };
      var entries = rvRead().filter(function (x) { return x.h !== exclude; }).slice(0, max);
      if (entries.length < 1) { box.hidden = true; return; }
      box.__ssRendering = true;
      Promise.all(entries.map(function (x) {
        return fetch(root + 'products/' + x.h + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error('rv'); } return r.json(); }).catch(function () { return null; });
      })).then(function (list) {
        var ul = box.querySelector('[data-ss-rv-list]');
        box.__ssRendering = false;
        var html = [];
        list.forEach(function (p, i) { if (p && p.available !== false) { html.push(rvCard(p, entries[i], fmt, T)); } });
        if (!html.length || !ul) { box.hidden = true; return; }
        ul.innerHTML = html.join('');
        Array.prototype.forEach.call(ul.querySelectorAll('.ss-rv__card'), function (li) { li.setAttribute('draggable', 'true'); });
        ul.classList.toggle('is-few', html.length < 4);
        rvDnD(ul);
        box.hidden = false;
      });
    });
  }
  window.SS_RV = { render: rvRender, record: rvRecord };
  var rvBox = document.querySelector('[data-ss-rv][data-ss-rv-record]:not([data-ss-rv-record=""])');
  if (rvBox) {
    var rvH = rvBox.getAttribute('data-ss-rv-record');
    var rvState = {};
    var vin = function () { return document.querySelector('#product--page [data-bstr-variant-input], #product--page form[action*="/cart/add"] [name="id"]'); };
    var initV = vin(); if (initV && initV.value) { rvState.v = initV.value; }
    rvRecord(rvH, rvState);
    var rvSync = function () { var i = vin(); if (i && i.value) { rvState.v = i.value; } rvRecord(rvH, rvState); };
    document.addEventListener('mouseover', function (e) { var sw = e.target.closest && e.target.closest('#product--page .swatch--color[data-swatch-option]'); if (sw) { rvState.c = sw.getAttribute('data-swatch-option'); } });
    document.addEventListener('click', function (e) { var sw = e.target.closest && e.target.closest('#product--page .swatch--color[data-swatch-option]'); if (sw) { rvState.c = sw.getAttribute('data-swatch-option'); setTimeout(rvSync, 300); } });
    window.addEventListener('pagehide', rvSync);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { rvSync(); } });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ss-rv-clear]');
    if (c) { e.preventDefault(); try { localStorage.removeItem(RV_KEY); } catch (er) {} var sec = c.closest('[data-ss-rv]'); if (sec) { sec.hidden = true; } }
    var rm = e.target.closest('[data-ss-rv-rm]');
    if (rm) {
      e.preventDefault(); e.stopPropagation();
      var li = rm.closest('.ss-rv__card'), ul = li && li.parentNode, box = rm.closest('[data-ss-rv]');
      if (!li) { return; }
      rvRemove(li.getAttribute('data-h'));
      li.classList.add('is-out');
      setTimeout(function () { if (li.parentNode) { li.parentNode.removeChild(li); } if (ul && !ul.children.length && box) { box.hidden = true; } else if (ul) { ul.classList.toggle('is-few', ul.children.length < 4); } }, 220);
    }
  });
  if (document.querySelector('[data-ss-rv]')) {
    if ('requestIdleCallback' in window) { requestIdleCallback(rvRender, { timeout: 1500 }); } else { setTimeout(rvRender, 300); }
  }

})();

  /* Run 6 : coloris numérotés (« 1 », « 2 »…) affichés « Coloris N » dans le titre du sélecteur (valeur Booster inchangée) */
  (function () {
    var spans = document.querySelectorAll('[data-swatch-selected-name][data-ss-numbered]');
    if (!spans.length || !('MutationObserver' in window)) return;
    function fix(el) {
      var t = (el.textContent || '').trim(); var m = t.match(/^:?\s*(\d{1,3})$/);
      if (m && el.getAttribute('data-ss-last') !== t) { var out = el.getAttribute('data-ss-numbered').replace('%n', m[1]); el.setAttribute('data-ss-last', out); el.textContent = (t.charAt(0) === ':' ? ': ' : '') + out; }
    }
    spans.forEach(function (el) { fix(el); new MutationObserver(function () { fix(el); }).observe(el, { childList: true, characterData: true, subtree: true }); });
  })();
